import { render } from "./LoginView.vue?vue&type=template&id=ec488ada&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=ec488ada&scoped=true&lang=css"

import exportComponent from "/Users/yinshuangyi/Documents/admin-house/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec488ada"]])

export default __exports__